import { reservaMeta } from "@/lib/labels";

/** Transfer-aware reservation badge (Reservado / En Bodega 11 / Transfer pend. / Sin transfer). */
export function ReservaBadge({ code, title }) {
  const m = reservaMeta(code);
  if (!m) return <span className="text-slate-300">—</span>;
  return (
    <span
      data-testid={`reserva-badge-${code}`}
      title={title || m.label}
      className="inline-flex items-center rounded-sm font-semibold whitespace-nowrap border px-2 py-0.5 text-[11px]"
      style={{ background: m.bg, color: m.text, borderColor: m.border }}
    >
      {m.label}
    </span>
  );
}
